import { render, staticRenderFns } from "./linkInvoice.vue?vue&type=template&id=0f5584a4&"
import script from "./linkInvoice.vue?vue&type=script&lang=js&"
export * from "./linkInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports